if(!customElements.get('swym-custom-add-to-wishlist')) {
  class swymCustomAddToWishlist extends HTMLElement {

    constructor() {
      super();
      this.initCalled = false;
    }

    allowDebug() {
      return this.classList.contains('debug');
    }

    init(){
      // if the component has already been initialized, do not re-init.
      if(this.initCalled) return;
      this.initCalled = true;
      this.hasCustomer = this.dataset.customer ? true : false;
      // gather elements
      this.setElements();
      // gather data for the product.
      this.setComponentProducts();
      if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: componentProducts", this.componentProducts, this);
      // fetch the current users lists from Wishlist Plus if any exist. If none exist, this should be an empty array.
      if(!this.elements.loginLink){
        if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: customer present, performing component render.", this);
        // After lists are set, find the default wishlist
        this.areProductsInWishlist = this.productsAreInList(window.swymDefaultWishlist);
        if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: are component products in the current wishlist?", this.areProductsInWishlist, this);
        // now that we have our default wishlist, we will render the component.
        this.renderComponent();
      } else {
        if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: no customer present, exiting component render.", this);
      }
      // set the event listeners.
      this.setEventListeners();
    }

    setElements(){
      this.elements = {};
      this.elements.templates = {};
      this.elements.templates.noCustomer = this.querySelector(`template#swym-no-customer`);
      this.elements.templates.addToWishlist = this.querySelector(`template#swym-add-to-wishlist-button`);
      this.elements.templates.addedToWishlist = this.querySelector(`template#swym-added-to-wishlist-button`);
      this.elements.activeState = this.querySelector('.swym-wishlist-state');
      this.elements.closestForm = this.closest('form');
      this.elements.closestBundleItem = this.closest('product-bundle-item');
      this.elements.closestProductOverview = this.closest('product-overview');
      this.elements.closesProductBundleOverview = this.closest('product-bundle-overview');
      this.elements.loginLink = this.querySelector('a.swym-login-link');
    }

    setEventListeners() {
      this.addEventListener('click', this.handleClick.bind(this));

      if (this.elements.closestProductOverview) {
        document.addEventListener('product-overview:variant-change', async (event) => {
          if (event.target.isEqualNode(this.elements.closestProductOverview)) {
            await this.refreshComponentState();
          }
        });
      }

      if (this.elements.closestBundleItem) {
        document.addEventListener('product-bundle-item:variant-change', async (event) => {
          if (event.target.isEqualNode(this.elements.closestBundleItem)) {
            await this.refreshComponentState();
          }
        });
      }

      if (this.elements.closesProductBundleOverview && !this.elements.closestBundleItem) {
        document.addEventListener('product-bundle-overview:variant-change', async (event) => {
          if (event.target.isEqualNode(this.elements.closesProductBundleOverview)) {
            await this.refreshComponentState();
          }
        });
      }
    }

    buildSuccessMessage(){
      let itemsHTML = ``
      if(this.elements.closestProductOverview){
        const productOverviewProduct = this.elements.closestProductOverview.getProduct();
        const productOverviewVariant = this.elements.closestProductOverview.getVariant();
        if(Object.keys(productOverviewVariant).length > 0){
          itemsHTML += `
            <div id="swym-custom-notification-content-${productOverviewVariant.id}" class="swym-custom-notification-content">
              <div class="swym-custom-image-container">
                <img class="swym-custom-image" src="${productOverviewVariant.featured_media}" alt="wishlisted product image"/>
              </div>
              <div class="swym-custom-title-container"><strong>${productOverviewProduct.title} - ${productOverviewVariant.title}</strong> has been added to <strong>1 list</strong> successfully</div>
            </div>
          `;
        }
      } else if(this.elements.closestBundleItem){
        const bundleItemVariant = this.elements.closestBundleItem.getVariant();
        if(Object.keys(bundleItemVariant).length > 0){
          itemsHTML += `
            <div id="swym-custom-notification-content-${bundleItemVariant.id}" class="swym-custom-notification-content">
              <div class="swym-custom-image-container">
                <img class="swym-custom-image" src="${bundleItemVariant.featured_media_url}" alt="wishlisted product image"/>
              </div>
              <div class="swym-custom-title-container"><strong>${bundleItemVariant.product_title} - ${bundleItemVariant.title}</strong> has been added to <strong>1 list</strong> successfully</div>
            </div>
          `;
        }
      } else if(this.elements.closesProductBundleOverview){
        const bundleItemVariants = this.elements.closesProductBundleOverview.getBundleVariants();
        bundleItemVariants.forEach((bundleItemVariant)=>{
          if(Object.keys(bundleItemVariant).length > 0){
            itemsHTML += `
              <div id="swym-custom-notification-content-${bundleItemVariant.id}" class="swym-custom-notification-content">
                <div class="swym-custom-image-container">
                  <img class="swym-custom-image" src="${bundleItemVariant.featured_media_url}" alt="wishlisted product image"/>
                </div>
                <div class="swym-custom-title-container"><strong>${bundleItemVariant.product_title} - ${bundleItemVariant.title}</strong> has been added to <strong>1 list</strong> successfully</div>
              </div>
            `;
          }
        });
      }
      const notificationHTML = `
        <style>
          .swym-notification-success-inner .swym-image{ display: none !important }
          .swym-custom-notification-content { display: flex; gap: 10px }
          .swym-notification-success-inner .swym-details-container .swym-details { display: flex; flex-flow: row wrap; gap: 10px }
          .swym-custom-notification-content .swym-custom-image-container { min-height: 50px; min-width: 50px; max-height: 50px; max-width: 50px }
          .swym-custom-notification-content .swym-custom-image-container .swym-custom-image { width: 100%; height: 100%; object-fit: cover }
          .swym-custom-notification-content .swym-custom-title-container { font-weight: 500; font-size: 14px }
        </style>
        ${itemsHTML}
      `;
      return notificationHTML;
    }

    renderSuccessMessage(){
      const successMessage = this.buildSuccessMessage();
      window.swat.ui.uiRef.showSuccessNotification({ message: successMessage });
    }

    async refreshComponentState() {
      if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: refreshComponentState()", this);
      this.setComponentProducts();
      if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: componentProducts", this.componentProducts, this);
      this.areProductsInWishlist = this.productsAreInList(window.swymDefaultWishlist);
      if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: are component products in the current wishlist?", this.areProductsInWishlist, this);
      this.renderComponent();
    }

    setComponentProducts() {
      if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: setComponentProducts.", this);
      this.componentProducts = this.extractProductData();
    }

    extractProductData() {
      const products = [];
      if(this.elements.closestProductOverview) {
        products.push(this.extractDataFromProductOverview());
      } else if(this.elements.closestBundleItem) {
        products.push(this.extractDataFromBundleItem());
      } else if(this.elements.closesProductBundleOverview) {
        products.push(...this.extractDataFromBundleOverview());
      }
      return products;
    }

    extractDataFromProductOverview() {
      const productOverview = this.elements.closestProductOverview;
      const productOverviewVariant = productOverview.getVariant();
      const productOverviewData =  {
        epi: productOverviewVariant.id,
        empi: productOverviewVariant.product_id,
        du: productOverviewVariant.url
      };
      return productOverviewData;
    }

    extractDataFromBundleItem() {
      const productBundleItem = this.elements.closestBundleItem.getVariant();
      return {
        epi: productBundleItem?.id,
        empi: productBundleItem?.product_id,
        du: productBundleItem?.url
      };
    }

    extractDataFromBundleOverview() {
      return this.elements.closesProductBundleOverview.getBundleVariants().map((variant) => ({
        epi: variant?.id,
        empi: variant?.product_id,
        du: variant?.url
      }));
    }

    getComponentProducts(){
      /*
        Simply return the wishlist products variable.
        This will either be an empty array (error), a single entry array (standard), or multiple entry array (bundles)
      */
      return this.componentProducts;
    }

    productsAreInList(swymWishlist){
      let productsAreInList = false;
      let matchingProductsCount = 0;
      // if we have a list, and we have product data from the component, see if the component products are found in the list.
      if (swymWishlist && swymWishlist.items && this.componentProducts && this.componentProducts.length > 0) {
        const productsToMatchCount = this.componentProducts.length;
        for (const product of this.componentProducts) {
          if (swymWishlist.items.some(item => item.epi === product.epi)) {
            matchingProductsCount++;
          }
          if (matchingProductsCount === productsToMatchCount){
            productsAreInList = true;
            break;
          }
        }
      }
      return productsAreInList;
    }

    renderComponent() {
      /*
        given the nearest wishlist button container (bundle item, bundle overview, product overview)
        determine if the relevant product id and variant id are in the wishlist.
        If the combo is in the wishlist, render the "added to wishlist" view, otherwise "add to wishlist"
        Check if any product data is undefined or null. If so, default to the 'addToWishlist' template
        with a 'disabled' class to indicate that adding to wishlist is not currently available.
      */

      if(!this.elements.activeState) {
        console.error('Error: swym-custom-add-to-wishlist: component state container is missing.');
        return;
      }

      let templateToUse;
      let disableComponent = false;

      if(!this.hasCustomer) {
        console.log("No customer is present, rendering redirect state");
        templateToUse = this.elements.templates.noCustomer;
        disableComponent = true;
      } else {
        const hasInvalidData = this.componentProducts.some(product => !product || !product.epi || !product.empi || !product.du);

        if (hasInvalidData) {
          console.log("component has invalid data");
          templateToUse = this.elements.templates.addToWishlist;
          disableComponent = true;
        } else {
          console.log("component has valid data");
          templateToUse = this.areProductsInWishlist ? this.elements.templates.addedToWishlist : this.elements.templates.addToWishlist;
          disableComponent = false;
        }
      }

      if(!templateToUse) {
        console.error('Error: swym-custom-add-to-wishlist: template content is unavailable.');
        return;
      }

      this.elements.activeState.innerHTML = ''; // Clear existing content
      const content = document.importNode(templateToUse.content, true);
      this.elements.activeState.appendChild(content); // Insert new content

      if (disableComponent) {
        this.classList.add('disabled');
      } else {
        this.classList.remove('disabled');
      }
    }

    isDisabled() {
      return this.classList.contains("disabled");
    }

    handleClick() {
      /*
        If we have clicked the component and we are in the "added to wishlist" state, remove the current product id - variant id combo from the wishlist.
        Otherwise we are in the "add to wishlist" state, and we need to add this data to the wishlist.
        Whether we add or remove from the lists, we need to re-render the component for an updated render based on the original init code.
      */

      if(this.isDisabled()) {
        if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: component is disabled.", this);
        return;
      }

      // this will probably never reach, but it feels clean.
      if(this.elements.loginLink) {
        if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: no customer present, exiting click event.", this);
        return;
      }

      // at this stage we are clicking the component, without the redirect link present.

      // if we can't get the default list, early exit.
      const listId = window.swymDefaultWishlist?.list?.lid
      if(!listId){
        if(this.allowDebug()) console.log("swym-custom-add-to-wishlist.js: no default wishlist present, exiting click event.", this);
        return;
      }

      const method = this.areProductsInWishlist ? 'removeProductsFromList' : 'addProductsToList';
      this.updateWishlist(method, listId, this.getComponentProducts())
        .then(() => {
          if(method === 'addProductsToList') this.renderSuccessMessage();
        })
        .catch(error => {
          console.error("Wishlist method failed", error);
        });
    }

    async updateWishlist(method, listId, products) {
      if(this.allowDebug()) console.log(`swym-custom-add-to-wishlist.js: ${method}, ${listId}, ${JSON.stringify(products)}`, this);
      return new Promise((resolve, reject) => {
        window.swat[method](listId, products, resolve, ({ error }) => {
          console.error(`Error during ${method}:`, error);
          reject(new Error(error));
        });
      });
    }

  }

  customElements.define('swym-custom-add-to-wishlist', swymCustomAddToWishlist);
}
